import { render, staticRenderFns } from "./AdminInput.vue?vue&type=template&id=2a1660d2&"
import script from "./AdminInput.vue?vue&type=script&lang=js&"
export * from "./AdminInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports